class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    if (this.tagName === 'CART-ITEMS') {
      this.checkCartThreshold();
    }
    
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        if (this.tagName === 'CART-ITEMS') {
          this.checkCartThreshold();
        }else{
           jQuery.getJSON('/cart.js', function(cart) { 
              var gwpVariantId = parseInt(document.querySelector('.gwp_variant').getAttribute('gwp_variant_id'));
             var gwpThreshold = parseInt(document.querySelector('.gwp_variant').getAttribute('gwp_threshold_price'));
               var total_price = cart.total_price / 100;
            var a,p,q;
             cart.items.forEach(function(a) {
                  if(a.id === gwpVariantId){p = a.id;}
                  if(a.id === 43146308354286 || a.id === 43146308387054 || a.id === 43434901537006 ){
                    q = a.handle;
                  }
            });
          if (total_price >= gwpThreshold && p !== gwpVariantId && q !== 'digital-gift-card'){
             
             let formData = {
                   'items': [{
                    'id': gwpVariantId,
                    'quantity': 1
                    }]
                  };
              
               fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                  })
                  .then(response => {
                    return response.json();
                  })
                  .then(response =>{
                    const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
                   cartItems.updateQuantity(1, 1);
                  })
          }
          else if((total_price < gwpThreshold && p === gwpVariantId) || (total_price >= gwpThreshold && q === 'digital-gift-card')){
              const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
                     var element = document.querySelector('.FreeProduct cart-remove-button');
                     var dataIndexValue = element.getAttribute('data-index');
                    cartItems.updateQuantity(dataIndexValue, 0); 
          }
           })
        }
        
        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  checkCartThreshold(){
  Shopify.Cart = Shopify.Cart || {};
  Shopify.Cart.GiftWrap = {
    refreshCart: function() {
      fetch('/cart?view=ajax')
        .then(response => {
          if (response.ok) {
            return Promise.resolve(response);
          }
          else {
            return Promise.reject(new Error('Failed to load'));
          }
        })
        .then(response => response.text())
        .then(data => {
          let cartDom = document.querySelector('cart-items');

          if(cartDom) {
            cartDom.innerHTML = data;
            var el = cartDom.querySelector('cart-items');
            var parent = document.querySelector('html');
            parent.innerHTML = data;
          }
        })
        .catch(function(error) {
          console.log('Error: ' + error.message);
        });
    },
    set: function(variantid, quantity){
      var headers = new Headers({ 'Content-Type': 'application/json' });

      var request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ id : variantid, quantity: quantity })
      };
      fetch('/cart/add.js', request)
        .then(function() {
          // Handle success
        });
      setTimeout(() => {
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(response => response.json())
          .then(data => { data; this.refreshCart(); });
      }, 300);
    },
    remove: function(productId){
      $.ajax({
        method: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
          quantity: 0,
          id: productId
        }
      }).then(function(result) {
        // Handle success
      });
      setTimeout(() => {
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(response => response.json())
          .then(data => { data; this.refreshCart(); });
      }, 300);
    }
  };

  jQuery.getJSON('/cart.js', function(cart) {
    var total_price = cart.total_price / 100;
    var giftCardInCart = false;
    var p;
    var gwpVariantId = document.querySelector('.gwp_variant').getAttribute('gwp_variant_id');
    var gwpThreshold = document.querySelector('.gwp_variant').getAttribute('gwp_threshold_price');
    cart.items.forEach(function(a) {
      if (a.id === parseInt(gwpVariantId)) {
        p = a.id;
      }
      if(a.id === 37172735049879 || a.id === 37172735082647 || a.id === 37172735115415 || a.id === 37172735148183 || a.id === 37172735180951 || a.id === 37172735213719 || a.id === 37172735246487 || a.id === 37172735279255 || a.id === 37172735312023 || a.id === 37172735344791 || a.id === 37172735377559 || a.id === 37172735410327 || a.id === 41556310392983 ){
                   giftCardInCart = true;
                    return; 
                  }
    });

    if (total_price >= parseInt(gwpThreshold) && p !== parseInt(gwpVariantId) && !giftCardInCart){
      Shopify.Cart.GiftWrap.set(parseInt(gwpVariantId),1);
    }else if(total_price < parseInt(gwpThreshold) && p === parseInt(gwpVariantId) && !giftCardInCart){
      Shopify.Cart.GiftWrap.remove(gwpVariantId);
    }
  });
}
  
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}




















/*

function updateTieredProgressBar() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const totalCents = cart.total_price;
      const total = totalCents / 100;
      const fill = document.getElementById('tiered-progress-fill');
      const percent = document.getElementById('current-percent');
      const msg = document.getElementById('tiered-progress-message');
      const notice = document.getElementById('discount-applied-notice');
      const appliedText = document.getElementById('applied-text');
      const tiers = [
        { thresh: 10000, disc: 10 },
        { thresh: 20000, disc: 15 },
        { thresh: 30000, disc: 25 }
      ];
      let currentDisc = 0;
      let nextThresh = 10000;
      for (const t of tiers) {
        if (totalCents >= t.thresh) currentDisc = t.disc;
        else { nextThresh = t.thresh; break; }
      }
      const progress = Math.min((totalCents / 30000) * 100, 100);
      fill.style.width = progress + '%';
      percent.textContent = Math.round(progress) + '%';
      if (totalCents >= 30000) {
        msg.innerHTML = `Max discount unlocked!`;
        notice.style.display = 'block';
        appliedText.textContent = '25% OFF Applied!';
      } else if (currentDisc > 0) {
        const needed = ((nextThresh - totalCents) / 100).toFixed(2);
        const nextDisc = tiers.find(t => t.thresh === nextThresh).disc;
        msg.innerHTML = `You are <strong style="color:#7c6c5a">$${needed}</strong> away from saving <strong>${nextDisc}% OFF</strong>!`;
        notice.style.display = 'block';
        appliedText.textContent = `${currentDisc}% OFF Applied!`;
      } else {
        const needed = ((10000 - totalCents) / 100).toFixed(2);
        msg.innerHTML = `Spend <strong style="color:#7c6c5a">$${needed}</strong> more for <strong>10% OFF</strong>!`;
        notice.style.display = 'none';
      }
    });
}
document.addEventListener('DOMContentLoaded', updateTieredProgressBar);
setInterval(updateTieredProgressBar, 800); 
document.body.addEventListener('click', () => setTimeout(updateTieredProgressBar, 500));
document.addEventListener('cart:updated', updateTieredProgressBar); */


function updateTieredProgressBar() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const totalCents = cart.total_price;
      const fill = document.getElementById('tiered-progress-fill');
      const percent = document.getElementById('current-percent');
      const msg = document.getElementById('tiered-progress-message');
      const notice = document.getElementById('discount-applied-notice');
      const appliedText = document.getElementById('applied-text');

      let progress = 0;
      let currentDisc = 0;
      let nextDisc = 10;
      let nextThreshCents = 10000;

      // ------- NEW 3-LEVEL LOGIC -------
      if (totalCents >= 30000) {
        progress = 100;
        currentDisc = 25;
      } else if (totalCents >= 20000) {
        progress = 50;
        currentDisc = 15;
        nextDisc = 25;
        nextThreshCents = 30000;
      } else if (totalCents >= 10000) {
        progress = 25;
        currentDisc = 10;
        nextDisc = 15;
        nextThreshCents = 20000;
      } else {
        progress = 0;
        currentDisc = 0;
        nextDisc = 10;
        nextThreshCents = 10000;
      }
      // ---------------------------------

      fill.style.width = progress + '%';
      percent.textContent = progress + '%';

      // MESSAGE LOGIC
      if (currentDisc === 25) {
        msg.innerHTML = `Max discount unlocked!`;
        notice.style.display = "block";
        appliedText.textContent = `25% OFF Applied!`;
      } else if (currentDisc > 0) {
        const needed = ((nextThreshCents - totalCents) / 100).toFixed(2);
        msg.innerHTML = `You are <strong style="color:#7c6c5a">$${needed}</strong> away from saving <strong>${nextDisc}% OFF</strong>!`;
        notice.style.display = "block";
        appliedText.textContent = `${currentDisc}% OFF Applied!`;
      } else {
        const needed = ((nextThreshCents - totalCents) / 100).toFixed(2);
        msg.innerHTML = `Spend <strong style="color:#7c6c5a">$${needed}</strong> more for <strong>10% OFF</strong>!`;
        notice.style.display = "none";
      }
    });
}

document.addEventListener('DOMContentLoaded', updateTieredProgressBar);
setInterval(updateTieredProgressBar, 800); 
document.body.addEventListener('click', () => setTimeout(updateTieredProgressBar, 500));
document.addEventListener('cart:updated', updateTieredProgressBar);
